import ApiClient from './ApiClient';

class PlanosResumoAPI extends ApiClient {
  constructor() {
    super('planos/resumo', { accountScoped: true });
  }
}

export default new PlanosResumoAPI();
